var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43775 14.2972C8.82338 13.9887 9.38494 14.0488 9.69671 14.4303C9.71033 14.4461 9.89324 14.6532 10.227 14.8618C10.6099 15.1011 11.1969 15.35 12 15.35C12.8031 15.35 13.39 15.1011 13.773 14.8618C13.9641 14.7423 14.1545 14.6018 14.3033 14.4303C14.615 14.0488 15.1766 13.9887 15.5622 14.2972C15.9503 14.6077 16.0133 15.1741 15.7028 15.5622C15.4304 15.8906 15.0873 16.1629 14.727 16.3882C14.1099 16.7738 13.1969 17.15 12 17.15C10.8031 17.15 9.89003 16.7738 9.27298 16.3882C8.91395 16.1638 8.56703 15.8913 8.2972 15.5622C7.98669 15.1741 8.04962 14.6077 8.43775 14.2972Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.25C10.25 10.9403 9.69033 11.5 8.99997 11.5C8.30961 11.5 7.74997 10.9403 7.74997 10.25C7.74997 9.55961 8.30961 8.99997 8.99997 8.99997C9.69033 8.99997 10.25 9.55961 10.25 10.25Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5C15.6903 11.5 16.25 10.9403 16.25 10.25C16.25 9.55961 15.6903 8.99997 15 8.99997C14.3096 8.99997 13.75 9.55961 13.75 10.25C13.75 10.9403 14.3096 11.5 15 11.5Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.09998C6.53236 2.09998 2.09998 6.53236 2.09998 12C2.09998 17.4676 6.53236 21.9 12 21.9C17.4676 21.9 21.9 17.4676 21.9 12C21.9 6.53236 17.4676 2.09998 12 2.09998ZM3.89998 12C3.89998 7.52647 7.52647 3.89998 12 3.89998C16.4735 3.89998 20.1 7.52647 20.1 12C20.1 16.4735 16.4735 20.1 12 20.1C7.52647 20.1 3.89998 16.4735 3.89998 12Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileOutline);
export default __webpack_public_path__ + "static/media/smile_outline.91ded8dda9956df6d4281d94897db738.svg";
export { ForwardRef as ReactComponent };